/* eslint-disable react/jsx-no-target-blank */
import { IconButton, useColorModeValue, VStack } from "@chakra-ui/react";

import { AiFillGithub } from "react-icons/ai";
import { ImLinkedin2 } from "react-icons/im";

const SocialHandle = () => {
  const buttonColor = useColorModeValue(
    "#e53e3e",
    "linear(to-b, #ffdda1, #b07844)"
  );

  return (
    <VStack
      position="fixed"
      zIndex={999}
      bottom={{ base: "none", sm: 5, md: 20, lg: 5 }}
      left={{ base: "none", sm: 5, md: 5, lg: 5 }}
    >
      <a href="https://github.com/suFi7867" target="_blank">
        <IconButton
          display={{ base: "none", md: "-webkit-inline-flex" }}
          size="md"
          borderRadius="20px"
          fontSize="4xl"
          colorScheme="red"
          bgGradient={buttonColor}
          icon={<AiFillGithub />}
        />
      </a>
      <a
        href="https://www.linkedin.com/in/sufiyan-shaikh-developer"
        target="_blank"
      >
        <IconButton
          display={{ base: "none", md: "-webkit-inline-flex" }}
          size="md"
          borderRadius="20px"
          fontSize="xl"
          bgGradient={buttonColor}
          colorScheme="red"
          icon={<ImLinkedin2 />}
        />
      </a>
    </VStack>
  );
};

export default SocialHandle;
